import { Component, Input, OnChanges, OnInit } from "@angular/core";
import { InputBoolean } from "ng-zorro-antd/core/util";
import { IAssigneeIdMap } from "@gtmhub/assignees";
import { UiAvatarSize } from "../../avatar.models";

const DEFAULT_MAX_AVATARS = 5;
@Component({
  selector: "ui-assignee-avatar-group",
  exportAs: "uiAssigneeAvatarGroup",
  templateUrl: "assignee-avatar-group.component.html",
  styleUrls: ["./assignee-avatar-group.component.less"],

  host: {
    class: "ui-assignee-avatar-group-wrapper",
    "[class.ui-assignee-avatar-group-x-small]": `size === 'xs'`,
    "[class.ui-assignee-avatar-group-small]": `size === 'sm'`,
    "[class.ui-assignee-avatar-group-medium]": `size === 'md'`,
    "[class.ui-assignee-avatar-group-large]": `size === 'lg'`,
    "[class.ui-assignee-avatar-group-x-large]": `size === 'xl'`,
    "[class.ui-align-right]": "alignRight",
  },
})
export class UiAssigneeAvatarGroupComponent implements OnInit, OnChanges {
  @Input("uiAssigneeIds")
  public assigneeIds?: string[] = [];

  @Input("uiAssigneesIdMap")
  public assigneesIdMap: IAssigneeIdMap;

  @Input("uiSize")
  public size?: UiAvatarSize = "md";

  @Input("uiMax")
  public max?: number = DEFAULT_MAX_AVATARS;

  @Input("uiAlignRight")
  @InputBoolean()
  public alignRight?: boolean;

  public sliceAvatarsUntilIndex: number = DEFAULT_MAX_AVATARS;

  public ngOnInit(): void {
    if (!this.assigneeIds) {
      this.assigneeIds = [];
    }
  }

  public ngOnChanges(): void {
    // In case that we have same number of assignees as max, +1 avatar is not displayed
    this.sliceAvatarsUntilIndex = this.max + (this.assigneeIds?.length <= this.max ? 1 : -1);
  }
}
